"use strict";

var _createClass = require("/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/helpers/classCallCheck.js");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var messageFormatter_1 = require("./messageFormatter");

var PostMessageCommunicator = /*#__PURE__*/_createClass(function PostMessageCommunicator() {
  var _this = this;

  var allowedOrigins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var debugMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  _classCallCheck(this, PostMessageCommunicator);

  this.allowedOrigins = null;
  this.callbacks = new Map();
  this.debugMode = false;

  this.isValidMessage = function (_ref) {
    var origin = _ref.origin,
        data = _ref.data,
        source = _ref.source;
    var emptyOrMalformed = !data;
    var sentFromParentEl = source === window.parent;
    var majorVersionNumber = typeof data.version !== 'undefined' && parseInt(data.version.split('.')[0]);
    var allowedSDKVersion = majorVersionNumber >= 1;
    var validOrigin = true;

    if (Array.isArray(_this.allowedOrigins)) {
      validOrigin = _this.allowedOrigins.find(function (regExp) {
        return regExp.test(origin);
      }) !== undefined;
    }

    return !emptyOrMalformed && sentFromParentEl && allowedSDKVersion && validOrigin;
  };

  this.logIncomingMessage = function (msg) {
    console.info("Safe Apps SDK v1: A message was received from origin ".concat(msg.origin, ". "), msg.data);
  };

  this.onParentMessage = function (msg) {
    if (_this.isValidMessage(msg)) {
      _this.debugMode && _this.logIncomingMessage(msg);

      _this.handleIncomingMessage(msg.data);
    }
  };

  this.handleIncomingMessage = function (payload) {
    var id = payload.id;

    var cb = _this.callbacks.get(id);

    if (cb) {
      cb(payload);

      _this.callbacks.delete(id);
    }
  };

  this.send = function (method, params) {
    var request = messageFormatter_1.MessageFormatter.makeRequest(method, params);

    if (typeof window === 'undefined') {
      throw new Error("Window doesn't exist");
    }

    window.parent.postMessage(request, '*');
    return new Promise(function (resolve, reject) {
      _this.callbacks.set(request.id, function (response) {
        if (!response.success) {
          reject(new Error(response.error));
          return;
        }

        resolve(response);
      });
    });
  };

  this.allowedOrigins = allowedOrigins;
  this.debugMode = debugMode;
  window.addEventListener('message', this.onParentMessage);
});

exports.default = PostMessageCommunicator;

__exportStar(require("./methods"), exports);